export const COOKIE_EXPIRATION_TIME_1_YEAR = 31536000; // 1 year in seconds
export const COOKIE_EXPIRATION_TIME_1_MONTH = 31536000; // 1 month in seconds
export const UP_ID_STORAGE_KEY = 'upId'; // Short for user profile id
